export default "__VITE_ASSET__CDoKiSy___"